import { sendGet } from "./axios";

export const getNominationPointByTherapist = (params) =>
  sendGet("/revenue/by-nomination-point", params);

